import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './../../styles/admin/cuentas_edit.css';
import * as globals from './../../components/GlobalScripts.js';
import { useParams, useNavigate , Link } from 'react-router-dom';
import { Pie, Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, ChartDataLabels);

const Admin_cuentas_edit = () => {
    let path_api = localStorage.getItem('path_api');
    const navigate = useNavigate();
    const { id } = useParams();
    const [categoriasOptions, setCategoriasOptions] = useState([]);
    const [estadosCiudades, setEstadosCiudades] = useState([]);
    const [user, setUser] = useState({});
    const [step, setStep] = useState(0);
    const [formDataUser, setFormDataUser] = useState({});
    const [formDataAccount, setFormDataAccount] = useState({});
    const [formDataAddress, setFormDataAddress] = useState({});
    const [formDataProfile, setFormDataProfile] = useState({
        profesion: 'Mudanzas',
        descripcion: '',
        estado: "todo el pais",
        ciudad: "todo el estado",
    });
    const [typeMsg, setTypeMsg] = useState('enviados');
    const [typeReview, setTypeReview] = useState('enviadas');
    const [intervalo_Grafica, setIntervalo_Grafica] = useState('1 Mes');
    const [msgEnviados, setMsgEnviados] = useState([]);
    const [msgRecibidos, setMsgRecibidos] = useState([]);
    const [reviewsEnviadas, setReviewsEnviadas] = useState([]);
    const [reviewsRecibidas, setReviewsRecibidas] = useState([]);
    const [notysRecibidas, setNotysRecibidas] = useState([]);
    const [pagosRealizados, setPagosRealizados] = useState([]);

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            if (userParsed) {
                setUser(userParsed);
            }
        }

        get_categorias();
        get_estados_ciudades();
        get_user('1 MONTH');
        setStep(0);
    }, [id]);

    const get_estados_ciudades = () => {
        axios.post(`${path_api}/default/get_estados_ciudades.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setEstadosCiudades(response.data.estados);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se cargaron los estados y ciudades",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar estados y ciudades",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });
    };

    const get_categorias = () => {
        axios.post(`${path_api}/default/get_categorias.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setCategoriasOptions(response.data.categorias);
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se cargaron las categorias", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al cargar las categorias", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
    };

    const get_user = (intervalo) => {
        globals.openViewCharge();
        axios.post(`${path_api}/admin/accounts/get_user.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            user_id: id,
            intervalo: intervalo
        }).then(response => {
            if (response.data.mensaje === 'success') {
                if (!Array.isArray(response.data.user.profile.profesiones)) {
                    response.data.user.profile.profesiones = [];
                }
                setFormDataUser(response.data.user);
                setFormDataAccount(response.data.user.account);
                setFormDataAddress(response.data.user.address);
                setFormDataProfile(response.data.user.profile);
                setMsgEnviados(response.data.mensajes_enviados);
                setMsgRecibidos(response.data.mensajes_recibidos);
                setReviewsEnviadas(response.data.reviews_enviadas);
                setReviewsRecibidas(response.data.reviews_recibidas);
                setNotysRecibidas(response.data.notificaciones_recibidas);
                setPagosRealizados(response.data.pagos_realizados);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvo la cuenta",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar la cuenta",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleSubmit_account = async (e) => {
        e.preventDefault();
        globals.openViewCharge();
        axios.post(`${path_api}/admin/accounts/update_account.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            user_id: id,
            formDataAccount: formDataAccount
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: 'success',
                    msg_title: 'Éxito',
                    msg: 'Cuenta actualizada exitosamente.',
                    effect: 'opacidad 2s, desplazamiento 2s',
                    time_life: 4000,
                });
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se actualizo la cuenta",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al actualizar la cuenta",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleSubmit_address = async (e) => {
        e.preventDefault();
        globals.openViewCharge();
        axios.post(`${path_api}/admin/accounts/update_address.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            user_id: id,
            rol: formDataUser?.rol,
            formDataAddress: formDataAddress
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: 'success',
                    msg_title: 'Éxito',
                    msg: 'Dirección actualizada exitosamente.',
                    effect: 'opacidad 2s, desplazamiento 2s',
                    time_life: 4000,
                });
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se actualizo la dirección",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al actualizar la dirección",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleSubmit_profile = async (e) => {
        e.preventDefault();
        globals.openViewCharge();
        axios.post(`${path_api}/admin/accounts/update_profile.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            user_id: id,
            rol: formDataUser?.rol,
            formDataProfile: formDataProfile
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: 'success',
                    msg_title: 'Éxito',
                    msg: 'Perfil actualizada exitosamente.',
                    effect: 'opacidad 2s, desplazamiento 2s',
                    time_life: 4000,
                });
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se actualizo la perfil",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al actualizar la perfil",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleChange_account = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormDataAccount({ ...formDataAccount, [name]: newValue });
    };

    const handleChange_address = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormDataAddress({ ...formDataAddress, [name]: newValue });
    };

    const handleChange_profile = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormDataProfile({ ...formDataProfile, [name]: newValue });
    };

    const messagesChartData = {
        labels: ['Mensajes enviados', 'Mensajes recibidos'],
        datasets: [
            {
                data: [msgEnviados.length, msgRecibidos.length],
                backgroundColor: ['#36A2EB', '#2ecc71'],
                hoverBackgroundColor: ['#36A2EB', '#2ecc71'],
            },
        ],
    };

    const messagesChartOptions = {
        maintainAspectRatio: false,
        aspectRatio: 4 / 3,
        plugins: {
            legend: {
                position: 'bottom',
            },
            datalabels: {
                color: '#fff',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: 4,
                padding: 4,
                font: {
                    weight: 'bold',
                    size: 14,
                },
                textShadowColor: '#000',
                textShadowBlur: 2,
                formatter: (value) => value,
            },
        },
    };

    const reviewsChartData = {
        labels: ['Reseñas enviadas', 'Reseñas recibidas'],
        datasets: [
            {
                data: [reviewsEnviadas.length, reviewsRecibidas.length],
                backgroundColor: ['#36A2EB', '#2ecc71'],
                hoverBackgroundColor: ['#36A2EB', '#2ecc71'],
            },
        ],
    };

    const reviewsChartOptions = {
        maintainAspectRatio: false,
        aspectRatio: 4 / 3,
        plugins: {
            legend: {
                position: 'bottom',
            },
            datalabels: {
                color: '#fff',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: 4,
                padding: 4,
                font: {
                    weight: 'bold',
                    size: 14,
                },
                textShadowColor: '#000',
                textShadowBlur: 2,
                formatter: (value) => value,
            },
        },
    };

    const notificationsChartData = {
        labels: ['Notificaciones recibidas'],
        datasets: [
            {
                label: 'Notificaciones',
                data: [notysRecibidas.length],
                backgroundColor: ['#f39c12'],
            },
        ],
    };

    const notificationsChartOptions = {
        maintainAspectRatio: false,
        aspectRatio: 4 / 3,
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                display: true,
                color: '#fff',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: 4,
                padding: 4,
                font: {
                    weight: 'bold',
                    size: 14,
                },
                formatter: (value) => value,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };

    const pagosChartOptions = {
        maintainAspectRatio: false,
        aspectRatio: 4 / 3,
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                display: true,
                color: '#fff',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: 4,
                padding: 4,
                font: {
                    weight: 'bold',
                    size: 14,
                },
                formatter: (value) => value,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };

    const pagosChartData = {
        labels: ['$ promedio de pagos('+pagosRealizados.length+')'],
        datasets: [
            {
                label: 'Precio promedio',
                data: [pagosRealizados.length > 0 ? pagosRealizados.reduce((acc, pago) => acc + pago.value, 0) / pagosRealizados.length : 0],
                backgroundColor: ['#f39c12'],
            },
        ],
    };

    const change_pagination_times_grafic = (e) => {
        let button = e.currentTarget;
        let parent = button.parentNode;
        let value = button.getAttribute('value');
        let es = button.getAttribute('es');

        parent.querySelector('.selected').classList.remove('selected');
        button.classList.add('selected');
        setIntervalo_Grafica(es);
        get_user(value);
    }

    const handleTypeMsgChange = (e) => {
        setTypeMsg(e.target.value);
    };

    const handleTypeReviewChange = (e) => {
        setTypeReview(e.target.value);
    };

    const niveles = ['Hierro', 'Bronce', 'Plata', 'Oro'];

    const handleAddProfession = (e) => {
        const profession = e.target.value;
        if (profession && !formDataProfile.profesiones?.includes(profession)) {
            setFormDataProfile(prev => ({
                ...prev,
                profesiones: [...prev.profesiones, profession]
            }));
        }
        e.target.value = "";
    };

    const handleRemoveProfession = (professionToRemove) => {
        setFormDataProfile(prev => ({
            ...prev,
            profesiones: prev.profesiones.filter(p => p !== professionToRemove)
        }));
    };

    return (
        <>
            <div className='page-cuentas-edit container-section medium-section flex-column gap-20'>
                <button onClick={() => navigate(-1)} className="flex-row gap-5 button-back">
                    <svg width="20" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.163 41.125L38.7085 55.6658L38.7088 55.6662C39.2779 56.2353 39.7294 56.9109 40.0374 57.6545C40.3454 58.3981 40.5039 59.1951 40.5039 60C40.5039 60.8049 40.3454 61.6018 40.0374 62.3454C39.7294 63.089 39.2779 63.7647 38.7088 64.3338C38.1397 64.9029 37.464 65.3544 36.7204 65.6624C35.9768 65.9704 35.1798 66.1289 34.375 66.1289C33.5701 66.1289 32.7732 65.9704 32.0296 65.6624C31.2859 65.3544 30.6103 64.9029 30.0412 64.3338L5.04386 39.3365C5.04297 39.3356 5.04207 39.3347 5.04118 39.3338M24.163 41.125L36.5875 12.2125C36.878 11.9219 37.1085 11.577 37.2658 11.1974C37.423 10.8178 37.5039 10.4109 37.5039 10C37.5039 9.5891 37.423 9.18222 37.2658 8.8026C37.1085 8.42298 36.878 8.07805 36.5875 7.7875C36.2969 7.49695 35.952 7.26647 35.5724 7.10923C35.1928 6.95198 34.7859 6.87105 34.375 6.87105C33.9641 6.87105 33.5572 6.95198 33.1776 7.10923C32.798 7.26647 32.453 7.49695 32.1625 7.7875L7.1625 32.7875C6.87148 33.0778 6.64059 33.4226 6.48305 33.8023C6.32551 34.1819 6.24441 34.589 6.24441 35C6.24441 35.411 6.32551 35.818 6.48305 36.1977C6.64059 36.5774 6.87148 36.9222 7.1625 37.2125L5.04118 39.3338M24.163 41.125H90.625C92.2494 41.125 93.8074 40.4797 94.956 39.331C96.1047 38.1824 96.75 36.6244 96.75 35C96.75 33.3755 96.1047 31.8176 94.956 30.669C93.8074 29.5203 92.2495 28.875 90.625 28.875H24.163L38.7085 14.3342L38.7088 14.3338C39.2779 13.7647 39.7294 13.089 40.0374 12.3454C40.3454 11.6018 40.5039 10.8049 40.5039 10C40.5039 9.19513 40.3454 8.39815 40.0374 7.65455C39.7294 6.91095 39.2779 6.2353 38.7088 5.66618C38.1397 5.09705 37.464 4.6456 36.7204 4.33759C35.9768 4.02958 35.1799 3.87105 34.375 3.87105C33.5701 3.87105 32.7731 4.02958 32.0296 4.33759C31.286 4.6456 30.6103 5.09705 30.0412 5.66618L5.04386 30.6635L7.16215 32.7871L5.04118 30.6662M24.163 41.125L5.04118 30.6662M5.04118 39.3338C4.47204 38.7654 4.02043 38.0905 3.71213 37.3475C3.40336 36.6034 3.24441 35.8056 3.24441 35C3.24441 34.1943 3.40336 33.3966 3.71213 32.6525C4.02043 31.9095 4.47204 31.2346 5.04118 30.6662M5.04118 39.3338L5.04118 30.6662" fill="var(--color-primary)" stroke="var(--color-primary)" strokeWidth="6" />
                    </svg>
                    <h4 style={{ color: "var(--color-primary)" }}>Volver</h4>
                </button>
                <div className='navigation-section'>
                    <span onClick={() => setStep(0)} className={step == 0 ? 'active-nav' : ''}>Todo</span>
                    <span onClick={() => setStep(1)} className={step == 1 ? 'active-nav' : ''}>Cuenta</span>
                    <span onClick={() => setStep(2)} className={step == 2 ? 'active-nav' : ''}>Dirección</span>
                    {formDataUser?.rol == 2 && (
                        <span onClick={() => setStep(3)} className={step == 3 ? 'active-nav' : ''}>Perfil</span>
                    )}
                    <span onClick={() => setStep(4)} className={step == 4 ? 'active-nav' : ''}>Graficas</span>
                    <span onClick={() => setStep(5)} className={step == 5 ? 'active-nav' : ''}>Mensajes</span>
                    <span onClick={() => setStep(6)} className={step == 6 ? 'active-nav' : ''}>Reseñas</span>
                    <span onClick={() => setStep(7)} className={step == 7 ? 'active-nav' : ''}>Notificaciones</span>
                    <span onClick={() => setStep(8)} className={step == 8 ? 'active-nav' : ''}>Pagos realizados</span>
                </div>
                {(step == 0 || step == 1) && (
                    <form onSubmit={handleSubmit_account} className="flex-column gap-20">
                        <div className='user-info'>
                            <h5><b>Rol:</b> {formDataUser?.rol === 1 ? 'Cliente' : 'Profesional'}</h5>
                            {formDataUser?.rol == 2 && (
                                <>
                                    <h5><b>Membresia:</b> {niveles[formDataUser?.nivel]}</h5>
                                    <h5><b>Balance:</b> {formDataUser?.balance}MXN</h5>  
                                </>
                            )}
                            <div className="form-group">
                                <label>Imagen de perfil</label>
                                <img
                                    src={path_api + formDataAccount?.img_profile}
                                    alt="Perfil"
                                />
                            </div>
                            <div className="form-grop-row">
                                <div className="form-group">
                                    <label htmlFor="nombre">Nombre(s)</label>
                                    <input
                                        type="text"
                                        id="nombre"
                                        name="nombre"
                                        value={formDataAccount?.nombre}
                                        onChange={handleChange_account}
                                        className="input-primary"
                                        placeholder="nombre"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="apellidos">Apellidos</label>
                                    <input
                                        type="text"
                                        id="apellidos"
                                        name="apellidos"
                                        value={formDataAccount?.apellidos}
                                        onChange={handleChange_account}
                                        className="input-primary"
                                        placeholder="apellidos"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formDataAccount?.email}
                                    onChange={handleChange_account}
                                    className="input-primary"
                                    placeholder="ejemplo@ejemplo.com"
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="phone">Telefono</label>
                                <input
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    value={formDataAccount?.phone}
                                    onChange={handleChange_account}
                                    className="input-primary"
                                    placeholder="--- --- ----"
                                    required
                                />
                            </div>

                            <div className="buttons-opt-inside">
                                <button className="button-primary" type="submit">
                                    Actualizar
                                </button>
                            </div>
                        </div>
                    </form>
                )}
                {(step == 0 || step == 2) && (
                    <form onSubmit={handleSubmit_address} className="flex-column gap-20">
                        <div className='user-info'>
                            <div className="form-group">
                                <label htmlFor="direccion">Dirección</label>
                                <input
                                    type="text"
                                    id="direccion"
                                    name="direccion"
                                    value={formDataAddress?.direccion}
                                    onChange={handleChange_address}
                                    className="input-primary"
                                    placeholder="roma #123"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="referencia">Referencia</label>
                                <input
                                    type="text"
                                    id="referencia"
                                    name="referencia"
                                    value={formDataAddress?.referencia}
                                    onChange={handleChange_address}
                                    className="input-primary"
                                    placeholder=""
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="apartamento">Apartamento</label>
                                <input
                                    type="text"
                                    id="apartamento"
                                    name="apartamento"
                                    value={formDataAddress?.apartamento}
                                    onChange={handleChange_address}
                                    className="input-primary"
                                    placeholder=""
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="estado">Estado</label>
                                <select
                                    id="estado"
                                    name="estado"
                                    value={formDataAddress?.estado}
                                    onChange={handleChange_address}
                                    className="input-primary"
                                    required
                                >
                                    <option value="">Selecciona un estado</option>
                                    {estadosCiudades.map((item, index) => (
                                        <option key={index} value={item.nombre}>
                                            {item.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="ciudad">Ciudad</label>
                                <select
                                    id="ciudad"
                                    name="ciudad"
                                    value={formDataAddress?.ciudad}
                                    onChange={handleChange_address}
                                    className="input-primary"
                                    required
                                >
                                    <option value="">Selecciona una ciudad</option>
                                    {(() => {
                                        const selectedState = estadosCiudades.find(
                                            (item) => item.nombre === formDataAddress?.estado
                                        );
                                        return selectedState && selectedState.ciudades
                                            ? selectedState.ciudades.map((ciudad) => (
                                                <option key={ciudad.id} value={ciudad.nombre}>
                                                    {ciudad.nombre}
                                                </option>
                                            ))
                                            : null;
                                    })()}
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="colonia">Colonia</label>
                                <input
                                    type="text"
                                    id="colonia"
                                    name="colonia"
                                    value={formDataAddress?.colonia}
                                    onChange={handleChange_address}
                                    className="input-primary"
                                    placeholder=""
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="cp">Código postal</label>
                                <input
                                    type="number"
                                    id="cp"
                                    name="cp"
                                    value={formDataAddress?.cp}
                                    onChange={handleChange_address}
                                    className="input-primary"
                                    placeholder=""
                                />
                            </div>

                            <div className="buttons-opt-inside">
                                <button className="button-primary" type="submit">
                                    Actualizar
                                </button>
                            </div>
                        </div>
                    </form>
                )}
                {(step == 0 || step == 3) && formDataUser.rol == 2 && (
                    <form onSubmit={handleSubmit_profile} className="flex-column gap-20">
                        <div className='user-info'>
                            <div className="form-group">
                                <label htmlFor="nombre_comercial">Nombre comercial</label>
                                <input
                                    type="text"
                                    id="nombre_comercial"
                                    name="nombre_comercial"
                                    value={formDataProfile.nombre_comercial}
                                    onChange={handleChange_profile}
                                    className="input-primary"
                                    placeholder="Nombre de la empresa"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="profesion">Profesión</label>
                                <select
                                    id="profesion"
                                    name="profesion"
                                    value={formDataProfile?.profesion}
                                    onChange={handleChange_profile}
                                    className="input-primary"
                                    required
                                >
                                    {categoriasOptions.map((categoria, index) => (
                                        <option key={index} value={categoria}>
                                            {categoria}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="profesiones">Profesiones secundarias</label>
                                <select
                                    id="profesiones"
                                    onChange={handleAddProfession}
                                    className="input-primary"
                                    defaultValue=""
                                >
                                    <option value="" disabled>— Selecciona una profesión —</option>
                                    {categoriasOptions
                                        .filter(cat => !formDataProfile?.profesiones?.includes(cat))
                                        .map((categoria, idx) => (
                                            <option key={idx} value={categoria}>
                                                {categoria}
                                            </option>
                                        ))}
                                </select>

                                <div className="selected-professions">
                                    {formDataProfile.profesiones?.map((prof, idx) => (
                                        <span key={idx}>
                                            {prof}
                                            <button type="button" onClick={() => handleRemoveProfession(prof)}>x</button>
                                        </span>
                                    ))}
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="descripcion">Describe brevemente los trabajos que realizas</label>
                                <textarea
                                    id="descripcion"
                                    name="descripcion"
                                    value={formDataProfile?.descripcion}
                                    onChange={handleChange_profile}
                                    className="input-primary"
                                    placeholder="Ej. Reparación y Servicio de Lavadoras y refrigeradores de todas las marcas."
                                    rows="4"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="estado">Estado donde realizas tu servicio</label>
                                <select
                                    id="estado"
                                    name="estado"
                                    value={formDataProfile?.estado}
                                    onChange={handleChange_profile}
                                    className="input-primary"
                                    required
                                >
                                    <option value="">Selecciona un estado</option>
                                    <option value="todo el pais">todo el pais</option>
                                    {estadosCiudades.map((item, index) => (
                                        <option key={index} value={item.nombre}>
                                            {item.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="ciudad">Ciudad donde realizas tu servicio</label>
                                <select
                                    id="ciudad"
                                    name="ciudad"
                                    value={formDataProfile?.ciudad}
                                    onChange={handleChange_profile}
                                    className="input-primary"
                                    required
                                >
                                    <option value="">Selecciona una ciudad</option>
                                    <option value="todo el estado">todo el estado</option>
                                    {(() => {
                                        const selectedState = estadosCiudades.find(
                                            (item) => item.nombre === formDataProfile?.estado
                                        );
                                        return selectedState && selectedState.ciudades
                                            ? selectedState.ciudades.map((ciudad) => (
                                                <option key={ciudad.id} value={ciudad.nombre}>
                                                    {ciudad.nombre}
                                                </option>
                                            ))
                                            : null;
                                    })()}
                                </select>
                            </div>

                            <h2>Identificación</h2>

                            <div className="form-grop-row">
                                <div className="form-group">
                                    <label>Frontal</label>
                                    {!formDataProfile?.identificacionFrontal_rute == 0 && (
                                        <img src={path_api + formDataProfile?.identificacionFrontal_rute} className='DNI' />
                                    )}
                                    {!formDataProfile?.identificacionFrontal_rute == 1 && (
                                        <span className='text-red'>Sin imagen para mostrar</span>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label>Trasera</label>
                                    {!formDataProfile?.identificacionTrasera_rute == 0 && (
                                        <img src={path_api + formDataProfile?.identificacionTrasera_rute} className='DNI' />
                                    )}
                                    {!formDataProfile?.identificacionTrasera_rute == 1 && (
                                        <span className='text-red'>Sin imagen para mostrar</span>
                                    )}
                                </div>
                            </div>
                            
                            {formDataProfile?.ocrResult?.tipo != '' && formDataProfile?.ocrResult?.tipo != null && (
                                <div className='summary'>
                                    <p><b>Tipo:</b> {formDataProfile?.ocrResult?.tipo}</p>
                                    <p><b>CIC:</b> {formDataProfile?.ocrResult?.cic}</p>
                                    <p><b>Codigo de validación:</b> {formDataProfile?.ocrResult?.codigoValidacion}</p>
                                    <p><b>OCR:</b> {formDataProfile?.ocrResult?.ocr}</p>
                                    <p><b>MRZ:</b> {formDataProfile?.ocrResult?.mrz}</p>
                                    <p><b>MRZ emisión:</b> {formDataProfile?.ocrResult?.validacionMRZ.emision}</p>
                                    <p><b>MRZ fecha de nacimiento:</b> {formDataProfile?.ocrResult?.validacionMRZ.fechaNacimiento}</p>
                                    <p><b>MRZ nombre:</b> {formDataProfile?.ocrResult?.validacionMRZ.nombre}</p>
                                    <p><b>MRZ sexo:</b> {formDataProfile?.ocrResult?.validacionMRZ.sexo}</p>
                                    <p><b>MRZ vigencia:</b> {formDataProfile?.ocrResult?.validacionMRZ.vigencia}</p>
                                </div>
                            )}

                            <div className="buttons-opt-inside">
                                <button className="button-primary" type="submit">
                                    Actualizar
                                </button>
                            </div>
                        </div>
                    </form>
                )}
                {(step == 0 || step == 4) && (
                    <div className='user-info'>
                        <div className="header-grafics">
                            <h4>En un lapso de {intervalo_Grafica}</h4>
                            <div className='pagination_times_grafic'>
                                <span value="1 DAY" es="1 Dia" className={intervalo_Grafica == '1 Dia'? 'selected': ''} onClick={change_pagination_times_grafic}><span>1D</span></span>
                                <span value="3 DAY" es="3 Dias" className={intervalo_Grafica == '3 Dias'? 'selected': ''} onClick={change_pagination_times_grafic}>3D</span>
                                <span value="7 DAY" es="7 Dias" className={intervalo_Grafica == '7 Dias'? 'selected': ''} onClick={change_pagination_times_grafic}>7D</span>
                                <span value="1 MONTH" es="1 Mes" className={intervalo_Grafica == '1 Mes'? 'selected': ''} onClick={change_pagination_times_grafic}>1M</span>
                                <span value="1 YEAR" es="1 Año" className={intervalo_Grafica == '1 Año'? 'selected': ''} onClick={change_pagination_times_grafic}>1A</span>
                            </div>
                        </div>
                        <div className="chart-grid-container">
                            <div className="chart-item">
                                <div style={{ position: 'relative', height: '200px' }}>
                                    <Pie data={messagesChartData} options={messagesChartOptions} />
                                </div>
                            </div>
                            <div className="chart-item">
                                <div style={{ position: 'relative', height: '200px' }}>
                                    <Pie data={reviewsChartData} options={reviewsChartOptions} />
                                </div>
                            </div>
                            <div className="chart-item">
                                <div style={{ position: 'relative', height: '200px' }}>
                                    <Bar data={notificationsChartData} options={notificationsChartOptions} />
                                </div>
                            </div>
                            <div className="chart-item">
                                <div style={{ position: 'relative', height: '200px' }}>
                                    <Bar data={pagosChartData} options={pagosChartOptions} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {(step == 0 || step == 5) && (
                    <div className='user-info'>
                        <div className="header-grafics">
                            <div className='left-section'>
                                <select value={typeMsg} onChange={handleTypeMsgChange} className="input-primary">
                                    <option value="enviados">Mensajes enviados</option>
                                    <option value="recibidos">Mensajes recibidos</option>
                                </select>
                                <h4>En un lapso de {intervalo_Grafica}</h4>
                            </div>
                            <div className='pagination_times_grafic'>
                                <span value="1 DAY" es="1 Dia" className={intervalo_Grafica == '1 Dia'? 'selected': ''} onClick={change_pagination_times_grafic}><span>1D</span></span>
                                <span value="3 DAY" es="3 Dias" className={intervalo_Grafica == '3 Dias'? 'selected': ''} onClick={change_pagination_times_grafic}>3D</span>
                                <span value="7 DAY" es="7 Dias" className={intervalo_Grafica == '7 Dias'? 'selected': ''} onClick={change_pagination_times_grafic}>7D</span>
                                <span value="1 MONTH" es="1 Mes" className={intervalo_Grafica == '1 Mes'? 'selected': ''} onClick={change_pagination_times_grafic}>1M</span>
                                <span value="1 YEAR" es="1 Año" className={intervalo_Grafica == '1 Año'? 'selected': ''} onClick={change_pagination_times_grafic}>1A</span>
                            </div>
                        </div>

                        {typeMsg == 'enviados' && msgEnviados.length > 0 && (
                            <>
                                <h5>{msgEnviados.length} {msgEnviados.length > 1? 'encontrados': 'encontrado'}</h5>
                                <div className="table-container">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Para</th>
                                                <th>Mensaje</th>
                                                <th>Estatus</th>
                                                <th>Fecha</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {msgEnviados.map(msg => (
                                                <tr key={msg.id}>
                                                    <td><Link to={'./../'+msg.other_key}>{msg.para}</Link></td>
                                                    <td>{msg.msg}</td>
                                                    <td>{msg.seen == 1 ? 'Leido' : 'No leido'}</td>
                                                    <td>{msg.createAt}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}

                        {typeMsg == 'recibidos' && msgRecibidos.length > 0 && (
                            <>
                                <h5>{msgRecibidos.length} {msgRecibidos.length > 1? 'encontrados': 'encontrado'}</h5>
                                <div className="table-container">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>De</th>
                                                <th>Mensaje</th>
                                                <th>Estatus</th>
                                                <th>Fecha</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {msgRecibidos.map(msg => (
                                                <tr key={msg.id}>
                                                    <td><Link to={'./../'+msg.other_key}>{msg.de}</Link></td>
                                                    <td>{msg.msg}</td>
                                                    <td>{msg.seen == 1 ? 'Leido' : 'No leido'}</td>
                                                    <td>{msg.createAt}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                )}
                {(step == 0 || step == 6) && (
                    <div className='user-info'>
                        <div className="header-grafics">
                            <div className='left-section'>
                                <select value={typeReview} onChange={handleTypeReviewChange} className="input-primary">
                                    <option value="enviadas">Reseñas enviadas</option>
                                    <option value="recibidas">Reseñas recibidas</option>
                                </select>
                                <h4>En un lapso de {intervalo_Grafica}</h4>
                            </div>
                            <div className='pagination_times_grafic'>
                                <span value="1 DAY" es="1 Dia" className={intervalo_Grafica == '1 Dia'? 'selected': ''} onClick={change_pagination_times_grafic}><span>1D</span></span>
                                <span value="3 DAY" es="3 Dias" className={intervalo_Grafica == '3 Dias'? 'selected': ''} onClick={change_pagination_times_grafic}>3D</span>
                                <span value="7 DAY" es="7 Dias" className={intervalo_Grafica == '7 Dias'? 'selected': ''} onClick={change_pagination_times_grafic}>7D</span>
                                <span value="1 MONTH" es="1 Mes" className={intervalo_Grafica == '1 Mes'? 'selected': ''} onClick={change_pagination_times_grafic}>1M</span>
                                <span value="1 YEAR" es="1 Año" className={intervalo_Grafica == '1 Año'? 'selected': ''} onClick={change_pagination_times_grafic}>1A</span>
                            </div>
                        </div>

                        {typeReview == 'enviadas' && reviewsEnviadas.length > 0 && (
                            <>
                                <h5>{reviewsEnviadas.length} {reviewsEnviadas.length > 1? 'encontrados': 'encontrado'}</h5>
                                <div className="table-container">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Para</th>
                                                <th>Rating</th>
                                                <th>Descripción</th>
                                                <th>Fecha</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reviewsEnviadas.map(review => (
                                                <tr key={review.id}>
                                                    <td><Link to={'./../'+review.other_key}>{review.para}</Link></td>
                                                    <td>{review.rating}</td>
                                                    <td>{review.description}</td>
                                                    <td>{review.createAt}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}

                        {typeReview == 'recibidas' && reviewsRecibidas.length > 0 && (
                            <>
                                <h5>{reviewsRecibidas.length} {reviewsRecibidas.length > 1? 'encontrados': 'encontrado'}</h5>
                                <div className="table-container">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>De</th>
                                                <th>Rating</th>
                                                <th>Descripción</th>
                                                <th>Fecha</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reviewsRecibidas.map(review => (
                                                <tr key={review.id}>
                                                    <td><Link to={'./../'+review.other_key}>{review.de}</Link></td>
                                                    <td>{review.rating}</td>
                                                    <td>{review.description}</td>
                                                    <td>{review.createAt}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                )}
                {(step == 0 || step == 7) && (
                    <div className='user-info'>
                        <div className="header-grafics">
                            <h4>Notificaciones en un lapso de {intervalo_Grafica}</h4>
                            <div className='pagination_times_grafic'>
                                <span value="1 DAY" es="1 Dia" className={intervalo_Grafica == '1 Dia'? 'selected': ''} onClick={change_pagination_times_grafic}><span>1D</span></span>
                                <span value="3 DAY" es="3 Dias" className={intervalo_Grafica == '3 Dias'? 'selected': ''} onClick={change_pagination_times_grafic}>3D</span>
                                <span value="7 DAY" es="7 Dias" className={intervalo_Grafica == '7 Dias'? 'selected': ''} onClick={change_pagination_times_grafic}>7D</span>
                                <span value="1 MONTH" es="1 Mes" className={intervalo_Grafica == '1 Mes'? 'selected': ''} onClick={change_pagination_times_grafic}>1M</span>
                                <span value="1 YEAR" es="1 Año" className={intervalo_Grafica == '1 Año'? 'selected': ''} onClick={change_pagination_times_grafic}>1A</span>
                            </div>
                        </div>

                        {notysRecibidas.length > 0 && (
                            <>
                                <h5>{notysRecibidas.length} {notysRecibidas.length > 1? 'encontradas': 'encontrada'}</h5>
                                <div className="table-container">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Notificación</th>
                                                <th>Estatus</th>
                                                <th>Fecha</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {notysRecibidas.map(noty => (
                                                <tr key={noty.id}>
                                                    <td>{noty.msg}</td>
                                                    <td>{noty.send == 1 ? 'Enviada' : 'No enviada'}</td>
                                                    <td>{noty.createAt}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                )}
                {(step == 0 || step == 8) && (
                    <div className='user-info'>
                        <div className="header-grafics">
                            <h4>Pagos realizados en un lapso de {intervalo_Grafica}</h4>
                            <div className='pagination_times_grafic'>
                                <span value="1 DAY" es="1 Dia" className={intervalo_Grafica == '1 Dia'? 'selected': ''} onClick={change_pagination_times_grafic}><span>1D</span></span>
                                <span value="3 DAY" es="3 Dias" className={intervalo_Grafica == '3 Dias'? 'selected': ''} onClick={change_pagination_times_grafic}>3D</span>
                                <span value="7 DAY" es="7 Dias" className={intervalo_Grafica == '7 Dias'? 'selected': ''} onClick={change_pagination_times_grafic}>7D</span>
                                <span value="1 MONTH" es="1 Mes" className={intervalo_Grafica == '1 Mes'? 'selected': ''} onClick={change_pagination_times_grafic}>1M</span>
                                <span value="1 YEAR" es="1 Año" className={intervalo_Grafica == '1 Año'? 'selected': ''} onClick={change_pagination_times_grafic}>1A</span>
                            </div>
                        </div>

                        {pagosRealizados.length > 0 && (
                            <>
                                <h5>{pagosRealizados.length} {pagosRealizados.length > 1? 'encontrados': 'encontrado'}</h5>
                                <div className="table-container">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Tipo</th>
                                                <th>Descripción</th>
                                                <th>Precio</th>
                                                <th>Fecha</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pagosRealizados.map(pago => (
                                                <tr key={pago.id}>
                                                    <td>{pago.type_sell}</td>
                                                    <td>{pago.descripcion}</td>
                                                    <td>${pago.value}{pago.divisa}</td>
                                                    <td>{pago.createAt}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default Admin_cuentas_edit;
